import {totalOf, withFilters as only} from 'core/History';

import {
  RecordsFilter,
  onlyWithinPeriod as within,
  onlyIncomes as incomes,
  onlySpends as spends,
  includedInBudget,
} from '../filters';

type AmountCalculator = (history: HistoryLog, period: Period) => MoneyAmount;

export function calculatorFor(recordsOfType: RecordsFilter): AmountCalculator {
  return function amountWithinPeriod(history: HistoryLog, period: Period): MoneyAmount {
    const filtered = only(recordsOfType, within(period), includedInBudget);
    return totalOf(filtered(history));
  };
}

export const addedWithinPeriod = calculatorFor(incomes);
export const spentWithinPeriod = calculatorFor(spends);
